import { Box } from "@mui/material";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../../context/ToasterContext";
import { useAppDispatch, useAppSelector } from "../../../hooks/storeHooks";
import { resetApiErrorEvent } from "../../../store/events/eventSlice";
import {
  acceptEventRequestThunk,
  declineEventRequestThunk,
} from "../../../store/events/eventThunk";
import { EventRequestStatusEnum, IRequest } from "../../../types/eventTypes";
import PrePaidCard from "../../reusable-components/cards/pre-paid-card/PrePaidCard";
import ShopifyDeclineModal from "../../reusable-components/modals/shopify-decline-modal/ShopifyDeclineModal";

interface IPrePaidRequestDetailProps {
  eventRequests: IRequest[];
}
const PrePaidRequestDetail = ({
  eventRequests,
}: IPrePaidRequestDetailProps) => {
  const [shopifyDeclineModalState, setShopifyDeclineModalState] =
    useState(false);

  const [declineRequestId, setDeclineRequestId] = useState("");
  const navigate = useNavigate();

  const apiError = useAppSelector((state) => state.events.apiError);
  const apiSuccess = useAppSelector((state) => state.events.apiSuccess);
  const dispatch = useAppDispatch();
  const { showToast } = useToast();
  const handleDeclineClick = useCallback(async (eventRequestId: string) => {
    setShopifyDeclineModalState(true);
    setDeclineRequestId(eventRequestId);
  }, []);

  const handleAcceptClick = useCallback(async (eventRequestId: string) => {
    dispatch(acceptEventRequestThunk(eventRequestId));
  }, []);

  useEffect(() => {
    if (apiError) {
      showToast(apiError.message, () => onToasterClose(), "error");
    }
    if (apiSuccess) {
      showToast(apiSuccess.message, () => onToasterClose(), "success");
    }
  }, [apiError, apiSuccess]);
  const onToasterClose = () => {
    dispatch(resetApiErrorEvent());
  };
  return (
    <Box
    sx={{
    display: "grid",
    gridTemplateColumns: { sm: "repeat(2, 1fr)", lg: "repeat(3, 1fr)" },
    rowGap: 3,
    columnGap: 2,
    mb: 2
    }}>
      {eventRequests.map((eventRequest) => {
        return (
          <Box>
            <PrePaidCard
              key={eventRequest.id}
              eventRequestId={eventRequest.id}
              title={eventRequest.name}
              declinedClick={(e) => {
                e.stopPropagation();
                handleDeclineClick(eventRequest.id);
              }}
              completedClick={(e) => {
                e.stopPropagation();
                handleAcceptClick(eventRequest.id);
              }}
              guestsCounter={eventRequest.guestCount + ""}
              date={moment(eventRequest.eventDate).format("DD MMMM YYYY")}
              AED={eventRequest?.price?.toFixed(2) + ""}
              expireAt={eventRequest.expireAt}
              openCardDetail={() => {
                navigate(`/event-detail/${eventRequest?.event?.id || ""}`);
              }}
              onHold={eventRequest.status === EventRequestStatusEnum.OnHold}
              startTime={eventRequest.startTime}
              customerNotes={eventRequest?.payload?.note ?? ""}
            />
          </Box>
        );
      })}
      <ShopifyDeclineModal
        modalHeaderText="Are you sure you want to Decline?"
        open={shopifyDeclineModalState}
        onClose={() => {
          setShopifyDeclineModalState(false);
          setDeclineRequestId("");
        }}
        shopifyDeclineModalBodyText="Are you sure you want to decline this event? This action can not be undone"
        declineOnClick={async () => {
          await dispatch(declineEventRequestThunk(declineRequestId));
          setShopifyDeclineModalState(false);
        }}
        backOnClick={() => {
          setShopifyDeclineModalState(false);
          setDeclineRequestId("");
        }}
      />
    </Box>
  );
};

export default PrePaidRequestDetail;
